import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit,} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-representative-details',
  templateUrl: './representative-details.component.html',
  styleUrls: ['./representative-details.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
})
export class RepresentativeDetailsComponent implements OnInit {
  @Input() salesManagerDetails = '';
  public currentId;
  public salesManagerObj = {name : '', email: '', phoneNumber: ''};

  ngOnInit(): void {
    this.getManagerDetails();
  }

  getManagerDetails() {
    const [name, email, phone] = this.salesManagerDetails.split('%');
    this.salesManagerObj.name = name;
    this.salesManagerObj.email = email;
    this.salesManagerObj.phoneNumber = phone;
  }

  openOutlook(email: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const urlStart = 'https://';
    const outlookWebUrl =
      urlStart + `outlook.office.com/mail/deeplink/compose?to=${email}`;
    /**  Open Outlook Web */
    const newWindow = window.open(outlookWebUrl, '_blank');
    /** Detect pop-up block */
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === 'undefined'
    ) {
      alert('Pop-up blocked! Please allow pop-ups for this site.');
    }
  }
}
